import type { IconDefinition } from '../index.tsx';

export const iconCreditCard: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconCreditCard',
  icon: [16, 16, [], '', 'M16 2H0V5H16V2Z M16 7H0V14H16V7Z'],
};
